import {combineReducers} from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import companies from './slices/companySlice'
import brandDetails from "./slices/brandDetailsSlice";

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        companies,
        brandDetails,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
